import { render, staticRenderFns } from "./DSTooltip.vue?vue&type=template&id=51b91ff0&"
import script from "./DSTooltip.vue?vue&type=script&lang=js&"
export * from "./DSTooltip.vue?vue&type=script&lang=js&"
import style0 from "./DSTooltip.vue?vue&type=style&index=0&id=51b91ff0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports